import { useEffect, useState } from 'react';
import {
  listOptimisticPosts,
  subscribeOptimisticPosts,
  type OptimisticPost,
} from './optimisticPosts';

/**
 * 楽観 (optimistic) pending 投稿ストアの購読 hook (docs/handoff_2026-06-03 根本対処)。
 *
 * `createPost` が送信直前に `addOptimisticPost` した投稿を同一タブで即時受け取り、地図に
 * pending ピンとして表示するために MapPage が使う。Firestore リスナーが同 doc を配信したら
 * MapPage 側で id 一致 dedup + ストアからの除去 (cleanup) を行う。
 *
 * 詳細な真因は [optimisticPosts.ts] 冒頭コメント参照。
 */
export function useOptimisticPosts(): OptimisticPost[] {
  // 初期値は lazy initializer でストア現在値を取得 (createPost が MapPage mount 前に登録した投稿も
  // 初回 render で拾える)。以降の変化は subscribe の callback で反映する。useOnlineStatus と同様に
  // mount 時の再同期 setState は置かない (react-hooks/set-state-in-effect 回避)。createPost は別画面
  // からのユーザー操作で発火するため、lazy init と subscribe の隙間で登録が起きるレースは実質ない。
  const [items, setItems] = useState<OptimisticPost[]>(() => listOptimisticPosts());

  useEffect(() => {
    return subscribeOptimisticPosts(() => setItems(listOptimisticPosts()));
  }, []);

  return items;
}
